<script lang="ts">
    import {authFetch} from "../Auth";
    import {strToLocaleDateTime} from "../Utils";
    import {getRouteById} from "../Nav";
    import {overlay} from "../Store";
    export const params = {}
    let list: any[] = []
    let count: number = 0
    let listPromise: Promise<any>
    let filter = {
        offset: 0,
        limit: 75,
        order: "DESC",
        orderBy: "id"
    }
    async function loadList() {
        let response = await authFetch('search-near/task-list', {
            method: 'POST',
            body: JSON.stringify(filter),
        })
        if (response.ok) {
            let data = await response.json()
            list = data.list
            count = data.count
        } else {
            alert(response.statusText)
        }
    }

    async function onExport(taskId){
        overlay.set('Downloading')
        try{
            let response = await authFetch(`search-near/export-zip`, {
                method: 'POST',
                body: JSON.stringify({
                    'taskId': taskId,
                }),
            })
            let filename = 'export.zip'
            if(response.ok){
                let header = response.headers.get('Content-Disposition');
                let parts = header!.split(';');
                if (parts.length > 0) {
                    filename = parts[1].split('=')[1];
                    filename = filename.replace(/(^"|"$)/g, '').trim();
                }

                let blob = await response.blob();
                let a = document.createElement('a');
                document.body.appendChild(a);

                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = filename;
                a.click();

                setTimeout(() => {
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                }, 10)
            } else {
                alert(response.statusText)
            }
        } catch (error) {
            console.error(error)
        }finally {
            overlay.set(null)
        }
    }
    function update(){
        listPromise = loadList()
    }
    update();
</script>
<table class="table table-bordered table-sm mt-3">
    <thead class="position-sticky bg-white shadow" style="z-index: 1030; top: 56px;">
    <tr style="border: 0px;">
        <th colspan="100">
            <div class="input-group justify-content-end">
                <button class="btn btn-info"
                        class:disabled={filter.offset===0}
                        on:click={()=>{filter.offset-=filter.limit;update()}}>
                    <i class="bi bi-chevron-left"></i>
                </button>
                <input class="form-control flex-grow-0" type="number" style="width: 5em;"
                       min="1"
                       max={Math.floor(count / filter.limit)+1}
                       step="1"
                       value={(filter.offset / filter.limit)+1}
                       on:change={(ev)=>{filter.offset=(ev.target.value - 1) * filter.limit; update()}}
                >
                <button class="btn btn-info disabled">
                    / {Math.floor(count / filter.limit)+1}
                </button>
                <button class="btn btn-info"
                        class:disabled={list.length < filter.limit}
                        on:click={()=>{filter.offset+=filter.limit;update()}}>
                    <i class="bi bi-chevron-right"></i>
                </button>
            </div>
        </th>
        <tr style="font-size: 14px;">
            <th>ID</th>
            <th>Назва</th>
            <th>Ширина</th>
            <th>Довжина</th>
            <th>Крок сітки</th>
            <th>К-сть точок</th>
            <th>Завершено</th>
            <th>Створений</th>
            <th></th>
        </tr>
    </thead>
    <tbody>
    {#await listPromise}
        <tr>
            <td colspan="1000" class="text-center">
                <div class="spinner-grow"></div>
            </td>
        </tr>
    {:then _}
        {#if list.length > 0}
            {#each list as task}
                <tr>
                    <td>{task.id}</td>
                    <td>{task.name}</td>
                    <td>{task.width}</td>
                    <td>{task.height}</td>
                    <td>{task.search_distance}</td>
                    <td>{task.total_points}</td>
                    <td>{task.finished_at ?? '-'}</td>
                    <td>{strToLocaleDateTime(task.created_at)}</td>
                    <td>
                        <a class="btn btn-sm btn-primary"
                           href="#{getRouteById('SearchNearTask').hash(task.id)}">Показати</a>
                        <button class="btn btn-sm btn-primary" on:click={onExport(task.id)} ><i class="bi bi-file-zip"></i></button>
                    </td>
                </tr>
            {/each}
        {:else}
            <tr>
                <td colSpan="1000" class="text-center">
                    <div class="alert alert-secondary">Немає завдань</div>
                </td>
            </tr>
        {/if}
    {/await}
    </tbody>
</table>